

export const filterHIPeaks = (masses: { mz: number; int: number }[], numberHIPeaks: number): { mz: number; int: number }[] => {
    if(masses.length === 0) return [];

    // filter out highest intensity peaks and return them
    return masses.sort((a, b) => b.int - a.int).slice(0, numberHIPeaks);
}